import { createContext, useContext, useMemo } from 'react';

import { useActions } from '@hivebrite/react-hooks';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { type EventGuests } from 'hb-react/types';

import { api } from '../actions';
import { useGuestsReducer } from '../hooks';

export type GuestApi = ReturnType<typeof api>;

const GuestsContext = createContext<{
  actions: GuestApi;
  guests: EventGuests['guests'];
}>({
  guests: [],
  // @ts-expect-error: fix later
  actions: {},
});

export default GuestsContext;

export const useGuestsContext = () => useContext(GuestsContext);

export const withGuestsContext = (Component) => (props) => {
  const contextValue = useGuestsContext();

  return <Component {...props} {...contextValue} />;
};

export const GuestsProvider = ({ children }) => {
  const { currentUser, updateCurrentUser } = useDefaultAppContexts();

  const { guests, dispatch } = useGuestsReducer({ currentUser });

  const actions = useActions(
    api({ currentUser, updateCurrentUser }),
    guests,
    dispatch,
  ) as GuestApi;

  const providerState = useMemo(() => ({ guests, actions }), [guests]);

  return (
    <GuestsContext.Provider value={providerState}>
      {children}
    </GuestsContext.Provider>
  );
};
